/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Avatar, Grid, Radio, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useLocation, useNavigate } from 'react-router-dom';
import Accordion from 'components/Common/Accordion/Accordion';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import { AlertTitleTh, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import { BtnBack, BtnConfirm, BtnSave, BtnSend } from 'components/Common/Button';
import ContentWrapper from 'components/Common/style/ContentWrapper';

import UserAvatar from "../../../../assets/Image/user-avatar.png";
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";
import { DialogActionCreators } from 'store/redux/DialogAlert';
import { useDispatch } from 'react-redux';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import moment from 'moment';

const UserPermissionForm = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [lstDataMenu, setlstDataMenu] = useState([]);
    const [nPermission, setnPermission] = useState(2)
    const [selectedValue, setSelectedValue] = useState({});
    const sEditUserID = location.state ? location.state["sID"] : null;
    const [IsResendEmail, setIsResendEmail] = useState(false)
    const [dLastLogin, setdLastLogin] = useState(null)
    const [IsBAAdmin, setIsBAAdmin] = useState(false)
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        nPageSize: 100,
        sSortExpression: "dUpdate",
        sSortDirection: "desc"
    });
    const [Option, setOption] = useState({
        lstRole: [],
        lstBA: []
    })

    const [OptionRole, setOptionRole] = useState([]);
    const [OptionBA, setOptionBA] = useState([]);
    const [sUserType, setUserType] = useState("PTT");
    const [IsHasAdmin, setHasAdmin] = useState(false)
    const [userImg, setUserImage] = useState(null);

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    //#region  Form
    let objSchema = {
        oEmployee: yupFormSchemas.object("รหัสพนักงาน - ชื่อ สกุล", { required: sUserType == "PTT" ? true : false }),
        oDepartment: yupFormSchemas.object("หน่วยงาน ปตท. (ฝ่าย)", { required: sUserType == "BSA" ? true : false }),
        sFName: yupFormSchemas.string("ชื่อ", { required: sUserType == "BSA" ? true : false }),
        sLName: yupFormSchemas.string("นามสกุล", { required: sUserType == "BSA" ? true : false }),
        sFNameEN: yupFormSchemas.string("First name", { required: sUserType == "BSA" ? true : false }),
        sLNameEN: yupFormSchemas.string("Last name", { required: sUserType == "BSA" ? true : false }),
        sEmail: yupFormSchemas.email("อีเมล", { required: sUserType == "BSA" ? true : false }),
        // arrRole: yupFormSchemas.stringArray("Role", { required: true }),
        arrRole: yupFormSchemas.object("Role", { required: true }),
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด (BA Admin)", { required: IsBAAdmin }),
        oStatus: yupFormSchemas.string("สถานะ", { required: true }),
        oUserType: yupFormSchemas.string("ประเภทผู้ใช้งาน", { required: true }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    const OptionStatus = [
        { value: "1", label: "ใช้งาน" },
        { value: "0", label: "ไม่ใช้งาน" },
    ]

    const OptionUserType = [
        { value: "PTT", label: "พนักงาน ปตท." },
        { value: "BSA", label: "BSA / Other" },
    ]


    useEffect(() => {
        setDataDefault()
        loadData();
    }, []);

    useEffect(() => {
        GetInit()
    }, [sUserType]);

    const setDataDefault = () => {
        form.setValue("oStatus", "1");
        form.setValue("oUserType", "PTT");
        GetInit()
    }

    const checkHasRoleAdmin = () => {
        let lstRole = form.getValues("arrRole")

        if (lstRole != null) {
            // role admin is 3

            if (lstRole.value == 3) {
                setHasAdmin(true);
            } else {

                setHasAdmin(false);
            }

            if (lstRole.value == 2) {
                setIsBAAdmin(true);
            } else {
                setIsBAAdmin(false);
                form.setValue("arrBA", []);
            }

            // if (lstRole.find(element => element == 3)) {
            //     setHasAdmin(true);
            // } else {

            //     setHasAdmin(false);
            // }

            // if (lstRole.find(element => element == 2)) {
            //     setIsBAAdmin(true);
            // } else {
            //     setIsBAAdmin(false);
            //     form.setValue("arrBA", []);
            // }
        }
    }

    const GetInit = () => {
        var oldRole = form.getValues("arrRole");
        form.setValue("arrRole", null);
        form.setValue("arrBA", []);
        setHasAdmin(false);
        setIsBAAdmin(false);
        AxiosGet("UserPermission/GetInitPrs", {}, (res) => {

            if (sUserType == "BSA") {
                res.optionRole = res.optionRole.filter(f => f.value != 3);
            }

            // if (oldRole != null) {
            //     var value = res.optionRole.filter(f => oldRole.includes(f.value));
            //     if (value != null) {
            //         form.setValue("arrRole", oldRole || []);
            //     }
            // }

            var result = {
                lstRole: res.optionRole,
                lstBA: res.optionBA
            }

            setOption(result)
            form.setValue("arrRole", oldRole);
        })
    }

    const loadData = (p: PaginationInterface = dataRow) => {
        // setLoadingTable(true);
        BlockUI();
        let data = {
            sUserID: sEditUserID === null ? "" : sEditUserID,
        }

        AxiosGet("UserPermission/GetDataPermission", data, (res) => {

            if (res.statusCode == 200) {
                UnBlockUI();
                setUserType(res.sUserType || "PTT");
                form.setValue("oUserType", res.sUserType || "PTT");
                if (res.oEmployee?.value != null) {
                    form.setValue("oEmployee", res.oEmployee)
                }
                form.setValue("sFName", res.sFName);
                form.setValue("sLName", res.sLName);
                form.setValue("sFNameEN", res.sFNameEN);
                form.setValue("sLNameEN", res.sLNameEN);

                if (res.oBSARefUnitCode?.value != null) {
                    form.setValue("oDepartment", res.oBSARefUnitCode);
                }
                form.setValue("sEmail", res.sEmail);

                if (res.sUserType == "BSA") {
                    res.lstRole = res.lstRole.filter(f => f != 3)
                }
                form.setValue("arrRole", res.oRole);
                form.setValue("arrBA", res.lstBA);

                if (sEditUserID != null) {
                    form.setValue("oStatus", res.sStatus);
                }

                onImgProfile(res?.sPathImage)

                setdLastLogin(res.dLastLogin)
                setIsResendEmail(res.IsResendEmail)

                checkHasRoleAdmin()
                // form.setValue("sPTTEmpName", res.oUser);
                setlstDataMenu(res.objPrs);
                setDataRow({
                    ...p,
                    arrRows: res.objPrs,
                    nDataLength: res.objPrs.length,
                    nPageIndex: 0,
                });

                // setLoadingTable(false);
            }
        })
    }

    const onImgProfile = (EmpCode) => {
        if (EmpCode) {
            const img = new Image()
            const baseUrl = process.env.REACT_APP_API_URL
            const sUrl = baseUrl + "UploadFile/PTTEmployeeImage/" + EmpCode + ".jpg";
            img.src = sUrl;
            var result = new Promise((resolve) => {
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
            });
            result.then(reustItem => {
                var img = reustItem ? sUrl : UserAvatar
                setUserImage(img)
            })
        } else {
            setUserImage(UserAvatar)
        }
    }

    const onSubmit = () => {
        let sMessage = "คุณต้องการที่จะบันทึกข้อมูลใช่หรือไม่ ?"
        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();

            let objData = {
                sUserID: sEditUserID === null ? "" : sEditUserID,
                objPrs: lstDataMenu,
                lstRole: form.getValues("arrRole") ? [form.getValues("arrRole").value] : null,
                lstBA: form.getValues("arrBA"),
                sUserType: sUserType,
                sFName: form.getValues("sFName"),
                sLName: form.getValues("sLName"),
                sFNameEN: form.getValues("sFNameEN"),
                sLNameEN: form.getValues("sLNameEN"),
                sEmpCode: form.getValues("oEmployee") != null ? form.getValues("oEmployee").value : null,
                sBSARefUnitCode: form.getValues("oDepartment") != null ? form.getValues("oDepartment").value : null,
                sEmail: form.getValues("sEmail"),
                sStatus: form.getValues("oStatus"),
            }

            AxiosPost("UserPermission/onSaveUserPermission", objData, (result) => {

                ResultAPI(result, "Saved successfully.", () => {

                    if (result.statusCode == "200" && (result.Message == null || result.Message == "")) {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        setTimeout(() => {
                            UnBlockUI();
                            navigate(`/Backend/Admin/UserPermissionList`)
                        }, 1000);

                    } else if (result.statusCode == "200") {
                        let sMessage = "มีข้อมูล Super Administrator ในกลุ่มตลาดนี้แล้ว ท่านต้องการบันทึกข้อมูลต่อหรือไม่ ?"
                        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
                            var objParam = {
                                ...objData,
                                IsAddSuperAdmin: true,
                                sUserID: result.sUserID
                            }
                            AxiosPost("UserPermission/onSaveUserPermission", objParam, (result) => {
                                if (result.statusCode == "200") {
                                    setIsOpenSnackbar(true);
                                    setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                                    setsSeveritySnackbar("success")
                                    setTimeout(() => {
                                        UnBlockUI();
                                        navigate(`/Backend/Admin/UserPermissionList`)
                                    }, 1000);

                                } else {

                                    setIsOpenSnackbar(true);
                                    setsMessageSnackbar(result.Message)
                                    setsSeveritySnackbar("warning")
                                    UnBlockUI();
                                }
                            }, (err) => {
                                setIsOpenSnackbar(true);
                                if (err.response.data.Message == "Employee Code is Duplicated.")
                                    setsMessageSnackbar("รหัสพนักงานซ้ำ!")
                                else if (err.response.data.Message == "Email is Duplicated.")
                                    setsMessageSnackbar("Email พนักงานซ้ำ!")
                                else
                                    setsMessageSnackbar(err.response.data.Message)
                                setsSeveritySnackbar("warning")
                                UnBlockUI();
                            })
                        }, () => {
                            UnBlockUI();
                            navigate(`/Backend/Admin/UserPermissionList`)
                        })

                    } else {

                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(result.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();
                    }
                });
            }, (err) => {
                setIsOpenSnackbar(true);
                if (err.response.data.Message == "Employee Code is Duplicated.")
                    setsMessageSnackbar("รหัสพนักงานซ้ำ!")
                else if (err.response.data.Message == "Email is Duplicated.")
                    setsMessageSnackbar("Email พนักงานซ้ำ!")
                else
                    setsMessageSnackbar(err.response.data.Message)
                setsSeveritySnackbar("warning")
                UnBlockUI();
                // if (!err.response) {
                //     //history("/error", {replace: true})
                //     return;
                // }
            });
        });
    }


    const handleChange = (e, item) => {
        selectedValue[item.nMenuID] = +e.target.value;
        setSelectedValue({ ...selectedValue });

        let lst = [...lstDataMenu];
        lst.forEach(data => {
            if (data.nMenuID === item.nMenuID) {
                item.nPermission = +e.target.value;
            }
        })
        let tempList = dataRow;
        // let tempRow = tempList.arrRows.filter((f) => f.sID == sID)[0];
        setDataRow({
            ...tempList,
        });
    };

    const onResend = () => {
        let sMessage = "คุณต้องการที่จะส่งอีเมลแจ้งเตือนใหม่อีกครั้งหรือไม่ ?"
        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost("Systems/BSAResendEmail", { sUserID: sEditUserID === null ? "" : sEditUserID }, (result) => {

                ResultAPI(result, "Re-send Email successfully.", () => {

                    if (result.statusCode == "200") {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("ส่งอีเมลแจ้งเตือนใหม่อีกครั้งสำเร็จ")
                        setsSeveritySnackbar("success")
                        UnBlockUI();

                    } else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(result.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();
                    }
                });
            }, (err) => {
                setIsOpenSnackbar(true);
                setsMessageSnackbar(err.response.data.Message)
                setsSeveritySnackbar("warning")
                UnBlockUI();
                // if (!err.response) {
                //     //history("/error", {replace: true})
                //     return;
                // }
            });
        });
    }

    const dataColumn = [
        {
            field: 'nRow',
            headerName: "ที่",
            headerAlign: "center",
            editable: false,
            align: "center",
            sortable: false,
            resizable: false,
            width: 60,
        },
        {
            field: 'sMenuName',
            headerName: 'เมนู',
            headerAlign: "center",
            align: "left",
            resizable: true,
            sortable: false,
            flex: 4,
            editable: false,
            minWidth: 100,
        },
        {
            field: 'IsEdit',
            headerName: 'เพิ่ม/ลบ/แก้ไข',
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            resizable: true,
            minWidth: 140,
            editable: false,
            renderCell: (item) => {
                let oDataMenu = lstDataMenu.find(x => x.nMenuID === item.row.nMenuID);
                return (
                    <Radio
                        checked={oDataMenu.nPermission === 2}
                        value={2}
                        onChange={(e) => handleChange(e, item.row)}
                        name={"rdb-permission" + item.row.nMenuID}
                        disabled={nPermission === 1}
                    />
                )
            },
        },
        {
            field: 'IsRead',
            headerName: 'อ่านเท่านั้น',
            flex: 1,
            headerAlign: "center",
            align: "center",
            minWidth: 140,
            sortable: false,
            editable: false,
            resizable: true,
            renderCell: (item) => {
                let oDataMenu = lstDataMenu.find(x => x.nMenuID === item.row.nMenuID);
                return (
                    <Radio
                        checked={oDataMenu.nPermission === 1}
                        value={1}
                        onChange={(e) => handleChange(e, item.row)}
                        name={"rdb-permission" + item.row.nMenuID}
                        disabled={nPermission === 1}
                    />
                )
            },
        },
        {
            field: 'IsPermission',
            headerName: 'ไม่มีสิทธิ์',
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            minWidth: 150,
            editable: true,
            resizable: true,
            renderCell: (item) => {
                let oDataMenu = lstDataMenu.find(x => x.nMenuID === item.row.nMenuID);
                return (
                    <Radio
                        checked={oDataMenu.nPermission === 0}
                        value={0}
                        onChange={(e) => handleChange(e, item.row)}
                        name={"rdb-permission" + item.row.nMenuID}
                        disabled={nPermission === 1}
                    />
                )
            },
        },
    ]


    return (
        <>
            <InnerHeadRoutes
                iconMUI={<ManageAccountsIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="ผู้ดูแลระบบ"
                label_nameRoute="จัดการข้อมูลผู้ใช้งาน"
            />
            <FormProvider {...form}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ marginTop: '0' }}>
                    <Grid item xs={12} sm={8}>
                        <Accordion header={"ข้อมูลผู้ใช้งาน"}>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                <Grid item xs={12}>
                                    <RadioFormItem
                                        name="oUserType"
                                        label="ประเภทผู้ใช้งาน"
                                        disable={sEditUserID != null ? true : false}
                                        required={true}
                                        options={OptionUserType}
                                        value={form.getValues("oUserType")}
                                        onChange={() => { setUserType(form.getValues("oUserType")); form.setValue("arrRole", null); form.setValue("oEmployee", null); setUserImage(UserAvatar); }}
                                        row={true}
                                        IsNewLine={false}
                                    />
                                </Grid>

                                {sUserType == "PTT" ?
                                    <Grid item xs={12} >
                                        <AsyncAutoComplete
                                            name="oEmployee"
                                            sUrlAPI={"User/SearchEmpAllPIS"}
                                            label={"รหัสพนักงาน - ชื่อ สกุล"}
                                            required={true}
                                            textSearch={"กรอกรหัสพนักงาน/ชื่อ/นามสกุล"}
                                            onChange={(e) => {
                                                if (e.value) {
                                                    onImgProfile(e.value)
                                                } else {
                                                    setUserImage(UserAvatar)
                                                }
                                            }}
                                        />
                                    </Grid>
                                    :
                                    <>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <InputFormItem
                                                id="sFName"
                                                name="sFName"
                                                label="ชื่อ"
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <InputFormItem
                                                id="sLName"
                                                name="sLName"
                                                label="นามสกุล"
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <InputFormItem
                                                id="sFNameEN"
                                                name="sFNameEN"
                                                label="First name"
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <InputFormItem
                                                id="sLNameEN"
                                                name="sLNameEN"
                                                label="Last name"
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputFormItem
                                                id="sEmail"
                                                name="sEmail"
                                                label="อีเมล"
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} >
                                            <AsyncAutoComplete
                                                name="oDepartment"
                                                sUrlAPI={"User/SearchUnitInfoOperation"}
                                                label={"หน่วยงาน ปตท. (ฝ่าย)"}
                                                required={true}
                                                textSearch={"กรอกรหัสหน่วยงาน/ชื่อหน่วยงาน"}
                                            />
                                        </Grid>
                                    </>
                                }

                                <Grid item xs={12} >
                                    <AutoCompleteSelect
                                        name="arrRole"
                                        options={Option.lstRole || []}
                                        label={"Role"}
                                        required={true}
                                        onChange={() => checkHasRoleAdmin()}
                                    />
                                    {/* <MultiSelectForm
                                        name="arrRole"
                                        options={Option.lstRole || []}
                                        label={"Role"}
                                        required={true}
                                        onChange={() => checkHasRoleAdmin()}
                                    /> */}
                                </Grid>

                                {IsBAAdmin &&
                                    <Grid item xs={12} >
                                        <MultiSelectForm
                                            name="arrBA"
                                            options={Option.lstBA || []}
                                            label={"กลุ่มตลาด (BA Admin)"}
                                            required={true}
                                        />
                                    </Grid>
                                }
                                <Grid item xs={12}>
                                    <RadioFormItem
                                        name="oStatus"
                                        label="สถานะ"
                                        required={true}
                                        options={OptionStatus}
                                        value={form.getValues("oStatus")}
                                        row={true}
                                        IsNewLine={false}
                                    />
                                </Grid>
                            </Grid>
                        </Accordion>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <div
                            style={{
                                width: '100%',
                                border: '1px solid #d5d5d5 !important',
                                padding: '16px',
                                borderRadius: '10px',
                                backgroundColor: '#fff',
                            }}
                        >
                            <Grid container spacing={2} justifyContent="end" alignItems="center">
                                <Grid item xs={12}>
                                    <Avatar src={userImg ?? ""} style={{ width: '9em', height: '9em', margin: '0 auto' }} />
                                </Grid>
                                <Grid item xs={12} style={{ textAlign: 'center' }}>
                                    <Typography>เข้าใช้งานล่าสุด: {dLastLogin != null ? moment(dLastLogin).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : "-"}</Typography>
                                </Grid>
                                {/* <Grid item >
                                    <span style={{ color: "#228dbd", textDecoration: "underline", cursor: "pointer" }}>เปลี่ยนรูปประจำตัว</span>
                                </Grid> */}

                                {/* re-send email */}
                                {IsResendEmail &&
                                    <Grid item xs={12}>
                                        <Grid container justifyContent="center" alignItems="center">
                                            <Grid item>
                                                <BtnSend txt="Re-send Email" onClick={(e) => onResend()} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                            </Grid>
                        </div>
                    </Grid>
                    {IsHasAdmin &&
                        <Grid item xs={12}>
                            <Accordion header={"กำหนดสิทธิ์เมนู"}>
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                    <Grid item xs={12} >
                                        <Table
                                            Rows={dataRow}
                                            Columns={dataColumn}
                                            isNotShowTotal={true}
                                            HiddenToolHead={true}
                                            isNotShowPagination={true}
                                            hideFooter={true}
                                            OnLoadData={(p) => loadData(p)}
                                        />
                                    </Grid>
                                </Grid>
                            </Accordion>
                        </Grid>
                    }
                    <Grid item xs={12} sm={12}>
                        <Grid container spacing={1} justifyContent="center" alignItems="center">
                            <Grid item>
                                <BtnConfirm txt='บันทึก' onClick={form.handleSubmit(() => { onSubmit() })} />
                            </Grid>
                            <Grid item>
                                <BtnBack onClick={() => navigate("/Backend/Admin/UserPermissionList")} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default UserPermissionForm